<template>
    <footer>
        <div class="container">
            <p>&copy; {{ this.getYear() }} Asia Actual. All rights reserved</p>
            <router-link to="/" class="image-link">
                <img src="@/assets/images/common/logo.png" alt="Asia Actual Logo"/>
            </router-link>
            <div class="user-actions">
                <router-link to="/login" v-if='!user'>
                    <p>Log In</p>
                </router-link>
                <!-- <router-link v-if='user' to="/search">
                    <a>Free Trial</a>
                </router-link> -->
                <router-link v-if='!user' to="/pricing-plan">
                    <a>Free Trial</a>
                </router-link>
                <router-link v-if='!user' to="/pricing-plan" class="orange-btn">
                    <p>Become a Member</p>
                </router-link>
            </div>
        </div>
    </footer>
</template>

<script>
import * as isUserLoggedIn from '@/store/isUserLoggedIn';
export default {
    name: 'footer',
    data() {
        return {
            user: isUserLoggedIn.isUserLoggedIn()
        }
    },

    methods: {
        getYear() {
            let d = new Date;
            return d.getFullYear();
        }
    }
}
</script>

<style lang="scss">
    footer {
        .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 50px;
            position: relative;
            max-width: 1320px;

            p {
                margin: 0;
            }

            .image-link {
                position: absolute;
                left: 50%;
                transform: translate(-50%, 0);
            }

            .user-actions {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 420px;

                a {
                    color: #333;
                }

                .orange-btn {
                    width: 210px;
                    background: linear-gradient(312.89deg, #FC7C05 7.78%, #FCAF05 75.92%);
                    color: #fff;
                }
            }
        }
    }
</style>